export default __webpack_public_path__ + "static/Entenda0001-df63096304b1b283e44e5fcd9b2ba884.jpg";